import { isEqual } from "lodash";

import {
    getListById,
    transformContainerFields,
} from "containers/Projects/components/ProjectTree/utils";

export const actions = {
    STORE_BUNDLE_LIST: "STORE_BUNDLE_LIST",
    STORE_ACTIVE_BUNDLE: "STORE_ACTIVE_BUNDLE",
};

export const initialState = {
    isFetching: false,
    list: [],
    activeId: null,
    listById: {},
};

export default (state = initialState, { type, data, iri }) => {
    switch (type) {
        case actions.STORE_BUNDLE_LIST: {
            const list = data.map(transformContainerFields);
            // The /ui websocket re-pushes the full bundle snapshot on any
            // workspace-scoped live update, not only when bundles changed.
            // Bail out when the content is identical so `list`/`listById` keep
            // their reference and downstream selectors/memoised consumers (e.g.
            // ProjectTree) do not re-render on every unrelated push.
            if (isEqual(state.list, list)) {
                return state;
            }
            const listById = getListById(data);
            return {
                ...state,
                list,
                listById,
            };
        }
        case actions.STORE_ACTIVE_BUNDLE: {
            return {
                ...state,
                activeId: iri,
            };
        }

        default:
            return state;
    }
};
